module.exports = __webpack_public_path__ + "media/customizations/cotavera/back-29fc80692ad82ef80e0921e220295550.jpg";